import { removeWhiteSpaces, cvvMaxLength, appendLeadingZeroes } from 'lib/fp-utility'
import FPConfig from 'lib/config'
import { callCardMetaDataAPI } from 'actions/payment'
import luhn from 'luhn'

export function scFormValidation(values){
    let errors = { sc: {}, standingInst: {} };
    if (!values.sc) {
        errors.sc = { cvv: 'Please enter valid cvv' };
    }
    if (values.sc && !values.sc.cvv) {
        errors.sc.cvv = "Please enter valid cvv";
    }
    if (values.sc && values.sc.cvv && values.sc.cvv.length < 3) {
        errors.sc.cvv = "Please enter valid cvv";
    }
    if (values.sc && !values.sc.hostedId) {
        errors.sc.hostedId = "Please select valid card";
    }

    errors.standingInst = { ...siValidation(values) }

    return errors;
}

export function cardFormValidation(values){
    let errors = { card: {}, standingInst: {}, cupCardBean: {} };
    if (!values.card) {
        errors.card = { cardNumber: "Please enter valid card number", expMonth: "Please enter valid card Month", expYear: "Please enter valid card Year", cVV: "Please enter valid card" };
    }
    if (values.card && !values.card.cardNumber) {
        window.localStorage.removeItem('readedCardNo')
        errors.card.cardNumber = "Please enter valid card number";
    }
    if (values.card && values.card.cardNumber) {
        const withoutWhiteSpace = removeWhiteSpaces(values.card.cardNumber)
        const card_no = withoutWhiteSpace.slice(0,6)
        const readedCardNo = window.localStorage.getItem('readedCardNo')
        const cardNumber = values.card.cardNumber
        const valueFrom = values.from
        // Get Card details and don't call API for the same card again
        if(withoutWhiteSpace.length >= 13 && readedCardNo !== card_no){
            window.localStorage.setItem('readedCardNo', card_no)
            const forMetaData = { cardNumber:withoutWhiteSpace, card_no, bankname: values.bankName, bankcode: values.bankCode }; 
            const anyError = cardMinMax(undefined, cardNumber)
            if(anyError)
                errors.card.cardNumber = anyError
            callCardMetaDataAPI(valueFrom, forMetaData).then((metaResult)=>{
                if(metaResult.data.response.errorCode){
                    // errors.card.cardNumber = "Please enter valid card number";
                    window.localStorage.removeItem('cardScheme')
                    window.localStorage.removeItem('cardType')
                    window.localStorage.removeItem('issuerName')
                    return true
                }else{
                    const { cardScheme, cardType, issuerName } = metaResult.data.response.cardDetail
                    window.localStorage.setItem('cardScheme', cardScheme)
                    window.localStorage.setItem('cardType', cardType)
                    window.localStorage.setItem('issuerName', issuerName)
                    const error = cardMinMax(cardScheme, cardNumber)
                    if(error)
                        errors.card.cardNumber = error
                }
            })
        }else if(card_no.length >= 6 && readedCardNo === card_no){
            const cardScheme = window.localStorage.getItem('cardScheme')
            const error = cardMinMax(cardScheme, cardNumber)
            if(error)
                errors.card.cardNumber = error
        } 
        else if(card_no.length < 6){ // Reset collected CardInfo
            window.localStorage.removeItem('readedCardNo')
            window.localStorage.removeItem('cardScheme')
            window.localStorage.removeItem('cardType')
            window.localStorage.removeItem('issuerName')
            errors.card.cardNumber = "Please enter valid card number";
        }
    }

    if (values.card && values.card.nameOnCard && values.card.nameOnCard.length < FPConfig.cardHoldernameMinLength) {
        errors.card.nameOnCard = "Please enter valid card name";
    }

    if (values.card && !values.card.expMonth) {
        errors.card.expMonth = "Please enter valid expiry date";
    }

    if (values.card && !values.card.expYear) {
        errors.card.expYear = "Please enter valid expiry date";
    }
    if (values.card && !values.card.cVV) {
        errors.card.cVV = "Please enter valid card CVV";
    }

    // Validating whether the selected Expiry Date is Present and Futer Day
    if (values.card && values.card.expMonth && values.card.expYear) {
        let getCurrentYear = new Date().getFullYear();
        getCurrentYear = getCurrentYear.toString().substr((values.from==='IDC' ? 0 : -2));
        let getCurrentMonth = appendLeadingZeroes(new Date().getMonth() + 1);
        if (parseInt(values.card.expYear) === parseInt(getCurrentYear) && parseInt(values.card.expMonth) < parseInt(getCurrentMonth)) {
            errors.card.expMonth = "invalidExpiry";
            errors.card.expYear = "invalidExpiry";
        }
    }

    const currentCardType = window.localStorage.getItem('cardScheme')
    if (values.card && values.card.cVV && values.card.cVV.length<cvvMaxLength(currentCardType)) {
        errors.card.cVV = "Please enter valid card CVV";
    }
    if(values.from === 'IDC'){
        if (values.card && !values.card.bankName) {
            errors.card.bankName = "Please select the bank";
        }
        /* IDebit comparing choosen bank and card bank */
        if (values.card && values.bankIssuerName && values.card.cardNumber) {
            const currentIssuerName = window.localStorage.getItem('issuerName')
            if(currentIssuerName !== 'undefined' && currentIssuerName!==values.bankIssuerName){
                errors.card.cardNumber = "Please enter valid card number";
            }
        }
    }

    /* Expiry and cvv optional for Maestro */
    if (window.localStorage.getItem('cardScheme') === 'MAESTRO'){
        const { expMonth, expYear, cVV, ...newError } = errors.card;
        errors.card = newError;
    }

    if(window.localStorage.getItem('cardScheme') === 'UNIONPAY'){
        if ( values.cupCardBean && !values.cupCardBean.stdCode) {
            errors.cupCardBean.stdCode = "Please select std code";
        }
        if ( values.cupCardBean && !values.cupCardBean.mobileNo) {
            errors.cupCardBean.mobileNo = "Please enter mobile number";
        }
        if (values.cupCardBean && (values.cupCardBean.mobileNo && values.cupCardBean.mobileNo.length < 4)) {
            errors.cupCardBean.mobileNo = "Please enter valid mobile number";
        }
    }

    errors.standingInst = { ...siValidation(values) }

    return errors;
}

// Validating Standing Instruction 
function siValidation(values){
    let standingInst = {}
    if(values.standingInstruction){
        if (!values.standingInst) {
            standingInst = { sIFrequency: "Select the duration", sIStartDate: "Enter the start date", sIEndDate: 'Enter the end date', sIAmtType: 'Select the amount type', maxDebitAmt: 'Enter the maximum debit amount' }
        }
        if (values.standingInst && !values.standingInst.sIFrequency) {
            standingInst.sIFrequency = "Select the duration";
        }
        if (values.standingInst && !values.standingInst.sIStartDate) {
            standingInst.sIStartDate = "Enter the start date";
        }
        if (values.standingInst && !values.standingInst.sIEndDate) {
            standingInst.sIEndDate = "Enter the end date";
        }
        if (values.standingInst && !values.standingInst.sIAmtType) {
            standingInst.sIAmtType = "Select the amount type";
        }
        if (values.standingInst && values.standingInst.sIAmtType==='maximum') {
            var reg = new RegExp('^[0-9]+$');

            if (values.standingInst && values.standingInst.sihubBean && !values.standingInst.sihubBean.siAmount) {
                standingInst.sihubBean = {...standingInst.sihubBean} || {}
                standingInst.sihubBean.siAmount  = "Enter the maximum debit amount";
            }else if(values.standingInst && !values.standingInst.sihubBean){
                standingInst.sihubBean = {...standingInst.sihubBean} || {}
                standingInst.sihubBean.siAmount = "Enter the maximum debit amount";
            }
            else if(values.standingInst && values.standingInst.sihubBean && values.standingInst.sihubBean.siAmount && !reg.test(values.standingInst.sihubBean.siAmount)){
                standingInst.sihubBean = {...standingInst.sihubBean} || {}
                standingInst.sihubBean.siAmount = "Enter valid amount";
            }
        }
        if(values.standingInst && values.standingInst.sihubBean && !values.standingInst.sihubBean.custEmailId){
            standingInst.sihubBean = {...standingInst.sihubBean} || {}
            standingInst.sihubBean.custEmailId = "Email is required"
        }
        if(values.standingInst && values.standingInst.sihubBean && values.standingInst.sihubBean.custEmailId){
           if(!validateEmail(values.standingInst.sihubBean.custEmailId)){
            standingInst.sihubBean = {...standingInst.sihubBean} || {}
            standingInst.sihubBean.custEmailId = "Email is not valid"
           }
            
        }
    }
    return standingInst
}

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

// Validating CardNumber Min, Max and isValid using Luhn Algorithm and allow only debit/credit card if card details come from debit/credit card page 
function cardNumberAndCardValidation(cardScheme, cardNumber, cardType, valueFrom){
    /* commenting since we won't get cardType and cardScheme for all the cards */
    // if(!cardScheme){
    //     return "Please enter valid card number";
    // }else if(cardScheme){
    //     const error = cardMinMax(cardNumber, cardScheme)
    //     if(error)
    //         return error;
    //     /* Debit card can't be typed in Credit card and Credit card can't be typed in Debit card  */
    //     if(valueFrom === FPConfig.cardDetail.debit.code && cardType !== FPConfig.cardDetail.debit.apiName){
    //         return "Please enter valid debit card number";
    //     }else if(valueFrom === FPConfig.cardDetail.iDebit.code && cardType !== FPConfig.cardDetail.debit.apiName){
    //         return "Please enter valid debit card number";
    //     }else if(valueFrom === FPConfig.cardDetail.credit.code && cardType !== FPConfig.cardDetail.credit.apiName){
    //         return "Please enter valid credit card number";
    //     }
    // }
}

export function cardMinMax(cardScheme, cardNumber){
    const cardNo = removeWhiteSpaces(cardNumber)
    const cLength = FPConfig.cardMinMaxLength[cardScheme]
    if (cLength.min > cardNo.length) {
        return "Please enter valid card number";
    } else if (cLength.max < cardNo.length) {
        return "Please enter valid card number";
    } else if (cLength.min <= cardNo.length && cLength.max >= cardNo.length && !luhn.validate(cardNo)) {
        return "Please enter valid card number";
    }
}

export function cardTypeValidation(cardType,from) {
    let fromType = false;
    if(from == "CC"){
        fromType = cardType === 'credit' ? true:false; 
    } else if(from == 'IDC' || from == "DC"){
        fromType = cardType === 'debit'? true:false; 
    }
    return fromType;
}